import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';

const MOCK = {
  wallet: '0xbEbD…5702',
  walletFull: '0xbEbD12a3c4E5f6789012345678901234abcd5702',
  qrId: 'qr__test123',
  label: 'Coffee Tips',
  balanceBNB: '0.0023',
  balanceTIP: '81,124.72',
};

export default function TestPWAPage() {
  const navigate = useNavigate();
  const [state, setState] = useState('disconnected');
  const [copied, setCopied] = useState(false);

  const qrUrl = `${window.location.origin}/tip/${MOCK.qrId}`;

  const fakeCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-screen py-6 px-4" style={{ backgroundColor: '#1a1a1a' }}>
      <div className="max-w-md mx-auto">

        {/* State switcher */}
        <div className="rounded-xl p-3 mb-6" style={{ backgroundColor: '#333' }}>
          <p className="text-xs mb-2 font-medium" style={{ color: '#888' }}>Test State Switcher</p>
          <div className="flex gap-2">
            {['disconnected', 'no-qr', 'has-qr'].map((s) => (
              <button key={s} onClick={() => setState(s)}
                className="text-xs px-3 py-1.5 rounded-lg font-medium transition-colors"
                style={{
                  backgroundColor: state === s ? '#f0b90b' : '#444',
                  color: state === s ? '#1a1a1a' : '#888',
                }}>
                {s === 'disconnected' ? 'No Wallet' : s === 'no-qr' ? 'No QR' : 'Has QR'}
              </button>
            ))}
          </div>
        </div>

        <h1 className="text-2xl font-bold mb-6" style={{ color: '#e8e3db' }}>My Dashboard</h1>

        {/* STATE: disconnected */}
        {state === 'disconnected' && (
          <div className="rounded-xl p-6 text-center" style={{ backgroundColor: '#2a2a2a' }}>
            <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4"
              style={{ backgroundColor: 'rgba(240,185,11,0.2)' }}>
              <svg className="w-7 h-7" fill="none" stroke="#f0b90b" viewBox="0 0 24 24" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m18 0V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v3" />
              </svg>
            </div>
            <p className="font-medium mb-2" style={{ color: '#e8e3db' }}>Connect your wallet</p>
            <p className="text-sm mb-4" style={{ color: '#888' }}>to access your dashboard</p>
            <button className="text-sm px-6 py-2.5 rounded-xl font-medium text-white"
              style={{ backgroundColor: '#f0b90b' }}
              onClick={() => setState('no-qr')}>
              Connect Wallet
            </button>
          </div>
        )}

        {/* STATE: connected, no QR */}
        {state === 'no-qr' && (
          <>
            <div className="rounded-xl p-3 mb-4" style={{ backgroundColor: '#2a2a2a' }}>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs" style={{ color: '#888' }}>Wallet</p>
                  <p className="font-mono text-sm" style={{ color: '#e8e3db' }}>{MOCK.wallet}</p>
                </div>
                <div className="text-right">
                  <p className="text-xs" style={{ color: '#888' }}>BNB {MOCK.balanceBNB}</p>
                  <p className="text-xs" style={{ color: '#f0b90b' }}>TIP {MOCK.balanceTIP}</p>
                </div>
              </div>
            </div>

            <div className="rounded-xl p-6" style={{ backgroundColor: '#2a2a2a' }}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: 'rgba(240,185,11,0.2)' }}>
                    <svg className="w-5 h-5" fill="none" stroke="#f0b90b" viewBox="0 0 24 24" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-medium" style={{ color: '#e8e3db' }}>Get Your QR Code</p>
                    <p className="text-xs" style={{ color: '#888' }}>Receive tips in person</p>
                  </div>
                </div>
                <button className="text-sm px-4 py-2 rounded-xl font-medium text-white transition-colors"
                  style={{ backgroundColor: '#f0b90b' }}
                  onClick={() => setState('has-qr')}>
                  Create QR
                </button>
              </div>
            </div>
          </>
        )}

        {/* STATE: connected, has QR */}
        {state === 'has-qr' && (
          <>
            <div className="rounded-xl p-3 mb-4" style={{ backgroundColor: '#2a2a2a' }}>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs" style={{ color: '#888' }}>Wallet</p>
                  <p className="font-mono text-sm" style={{ color: '#e8e3db' }}>{MOCK.wallet}</p>
                </div>
                <div className="text-right">
                  <p className="text-xs" style={{ color: '#888' }}>BNB {MOCK.balanceBNB}</p>
                  <p className="text-xs" style={{ color: '#f0b90b' }}>TIP {MOCK.balanceTIP}</p>
                </div>
              </div>
            </div>

            <div className="rounded-xl p-5" style={{ backgroundColor: '#2a2a2a' }}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: '#f0b90b' }}>
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium" style={{ color: '#e8e3db' }}>My QR Code</p>
                  <p className="text-xs" style={{ color: '#888' }}>Share it anywhere</p>
                </div>
              </div>

              <div className="flex justify-center mb-4">
                <div className="bg-white p-4 rounded-xl">
                  <QRCodeSVG value={qrUrl} size={160} level="H" includeMargin={true} />
                </div>
              </div>

              <p className="text-center text-sm mb-3" style={{ color: '#888' }}>{MOCK.label}</p>

              <div className="flex gap-2 justify-center">
                <button onClick={fakeCopy}
                  className="flex items-center gap-2 text-sm px-3 py-2 rounded-xl border transition-colors"
                  style={{ borderColor: '#444', color: '#e8e3db' }}>
                  {copied ? (
                    <><svg className="w-4 h-4 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>Copied!</>
                  ) : (
                    <><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9.75a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184"/></svg>Copy</>
                  )}
                </button>
                <button className="flex items-center gap-2 text-sm px-3 py-2 rounded-xl border transition-colors"
                  style={{ borderColor: '#444', color: '#e8e3db' }}>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/></svg>
                  Download
                </button>
                <button className="flex items-center gap-2 text-sm px-3 py-2 rounded-xl border transition-colors"
                  style={{ borderColor: '#444', color: '#e8e3db' }}>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"/></svg>
                  Share
                </button>
              </div>
            </div>
          </>
        )}

        {/* Scan QR test button */}
        {state === 'has-qr' && (
          <div className="rounded-xl p-4 mt-4" style={{ backgroundColor: '#2a2a2a' }}>
            <p className="text-xs mb-2 font-medium" style={{ color: '#888' }}>Test Tipping Flow</p>
            <button
              onClick={() => navigate('/tip/qr__test123')}
              className="w-full flex items-center justify-center gap-2 text-sm px-4 py-3 rounded-xl font-medium text-white transition-colors"
              style={{ backgroundColor: '#f0b90b' }}>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 3.75H6A2.25 2.25 0 003.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0120.25 6v1.5M20.25 16.5V18A2.25 2.25 0 0118 20.25h-1.5M3.75 16.5V18A2.25 2.25 0 006 20.25h1.5" />
              </svg>
              Simulate QR Scan (opens /tip/qr__test123)
            </button>
          </div>
        )}

      </div>
    </div>
  );
}
